import React, { Component } from "react";
import { Container } from "reactstrap";
import { inject, observer } from "mobx-react";
import DataWrapper from "../../../principal/containers/DataWrapper";
import NotaFiscalFaturamentoStore from "../stores/NotaFiscalFaturamentoStore";
import FiltrosNotaFiscalFaturamento from "../components/FiltrosNotaFiscalFaturamento";
import TabelaNotaFiscalFaturamento from "../components/TabelaNotaFiscalFaturamento";
import lscache from "lscache";
import IconButton from "../../../comum/components/IconButton";
import Footer from "../../../comum/components/Footer";
import FooterContent from "../../../comum/components/FooterContent";
import FooterOptions from "../../../comum/components/FooterOptions";
import ExportToXls from "../../../comum/components/ExportToXls";
import { makePDF } from "../../../../utils/formatar";

@inject("store")
@DataWrapper
@observer
export class NotaFiscalFaturamento extends Component {
  constructor(props) {
    super(props);
    this.appStore = this.props.store.appStore;
    this.loginStore = this.props.store.loginStore;
    this.tituloPaginaStore = this.props.store.tituloPaginaStore;
    this.notaTecon = "";

    this.controller = new NotaFiscalFaturamentoStore();
  }

  componentDidMount() {
    this.tituloPaginaStore.setTitulo("Consulta Nota Fiscal Faturamento");

    let notaTeconParam = _.get(this.props.location.state, `notaTecon`);
    let voltarParam = _.get(this.props.location.state, `voltar`);
    this.notaTecon = notaTeconParam ? notaTeconParam : "";

    if (this.notaTecon) {
      lscache.set("acompProcesso-pesquisa-voltar", 5);
      this.controller.setFiltroSelecionado("numNota", this.notaTecon);
      this.controller.carregarDadosConsulta();
    }

    this.appStore.showTopbar(true);
    this.appStore.showVoltarTopBar(
      voltarParam ? true : false,
      voltarParam ? voltarParam : "/"
    );
  }

  render() {
    const data = this.controller.dadosConsulta
    const qtdeDados = data ? data.length : 0
    return (
      <div className="form-wrapper">
        <Container className="agendamento" fluid>
          <FiltrosNotaFiscalFaturamento
            controller={this.controller}
            notaTecon={
              _.get(this.props.location.state, `notaTecon`)
                ? _.get(this.props.location.state, `notaTecon`)
                : false
            }
          />
          <TabelaNotaFiscalFaturamento controller={this.controller} />
        </Container>
        <Footer>
          {
            this.controller.filtrado &&
            <FooterContent>
              <div className="justify-content-between">
                <div>
                  <b>{qtdeDados}</b> registro{qtdeDados > 1 ? "s" : ""} <a onClick={() => this.controller.carregarDadosConsulta()}>Atualizar Lista</a>
                </div>
              </div>
            </FooterContent>
          }
          <FooterOptions>
            <div>
              <IconButton
                icon="file-pdf"
                text="Baixar PDF"
                size="md"
                disabled={qtdeDados === 0}
                onClick={() =>
                  makePDF(
                    data,
                    this.controller.columnsToExport.map(c => c.dataField),
                    this.controller.columnsToExport.map(c => c.text),
                    [],
                    true,
                    false,
                    { qtdColFixo: "A2", nomeDoArquivo: "ProtocoloEletrônico.pdf" }
                  )
                }
              />
            </div>
            <div>
              <ExportToXls columns={this.controller.columnsToExport} dataSource={data} filename={"ProtocoloEletrônico"} />
            </div>
          </FooterOptions>
        </Footer>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/faturamento/notafiscal/tela/NotaFiscalFaturamento.js